import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";

class BritishColumbiaObstetricalFileSection5 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private AssistedReproductiveTechnology_OtherId = "AssistedReproductiveTechnology_Other";
    private AssistedReproductiveTechnology_IntracytoplasmicSpermInjectionId = "AssistedReproductiveTechnology_IntracytoplasmicSpermInjection";
    private AssistedReproductiveTechnology_InVitroFertilizationId = "AssistedReproductiveTechnology_InVitroFertilization";

    public render(): JSX.Element {
        const section5 = this.props.form.Section5;
        const assistedReport = section5.AssistedReproductiveTechnology;

        return (
            <div className="section border border-bottom">
                <div className="row row-form">
                    {this.renderHeader(
                        "ObstetricalFile_PresentPregnancyLabel",
                        5
                    )}
                    <div className="col-md-12">
                        {this.renderNoYesTitleSection5To9()}
                        <div className="flex-display padding-sm-top">
                            {this.controlRenderer.renderInlineRadio({
                                value: assistedReport.HasAssistedReproductiveTechnology,
                                items: this.getFalseTrueRadioOptionsWithoutLabel(),
                                onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section5.AssistedReproductiveTechnology.HasAssistedReproductiveTechnology = value),
                                id: "PresentPregnancy_HasAssistedReproductiveTechnology",
                                className: "radios-one-label",
                                optionSpacing: "15px"
                            })}
                            <label className="margin-none margin-xs-left">{this.getString("AssistedReproductiveTechnologyAbbreviationLabel")}</label>
                        </div>
                        {this.renderRadioCheckboxWithLabel(
                            "PresentPregnancy_OvarianStimulationOnly",
                            "ObstetricalFile_OvarianStimulationOnlyLabel",
                            assistedReport.HasOvarianStimulation,
                            value => this.mutateAssistedReproductiveTechnologyModel(
                                s => {
                                    s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();
                                    s.Section5.AssistedReproductiveTechnology.HasOvarianStimulation = value;
                                },
                                true
                            )
                        )}
                        {this.renderRadioCheckboxWithLabel(
                            "PresentPregnancy_IUIOnly",
                            "ObstetricalFile_IntrauterineInseminationAbbreviationOnlyLabel",
                            assistedReport.HasIntrauterineInsemination,
                            value => this.mutateAssistedReproductiveTechnologyModel(
                                s => {
                                    s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();
                                    s.Section5.AssistedReproductiveTechnology.HasIntrauterineInsemination = value;
                                },
                                true
                            )
                        )}
                        {this.renderRadioCheckboxWithLabel(
                            "OvarianStimulationOnlyPlusIUI",
                            "ObstetricalFile_OvarianStimulationPlusIntrauterineInseminationAbbreviationLabel",
                            assistedReport.HasOvarianStimulationPlusIUI,
                            value => this.mutateAssistedReproductiveTechnologyModel(
                                s => {
                                    s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();
                                    s.Section5.AssistedReproductiveTechnology.HasOvarianStimulationPlusIUI = value;
                                },
                                true
                            )
                        )}
                        {this.renderRadioCheckboxWithLabel(
                            "PresentPregnancy_IVF",
                            "InVitroFertilizationAbbreviationLabel",
                            assistedReport.InVitroFertilization.Value,
                            value => {
                                this.mutateAssistedReproductiveTechnologyModel(
                                    s => {
                                        s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();
                                        s.Section5.AssistedReproductiveTechnology.InVitroFertilization.Value = value;
                                    },
                                    true,
                                    () => this.setFocusTextbox(value, this.AssistedReproductiveTechnology_InVitroFertilizationId)
                                );
                            },
                            this.getAdditionalTextBox({
                                id: this.AssistedReproductiveTechnology_InVitroFertilizationId,
                                label: <span># {this.getString("ObstetricalFile_EmbryosTransferredLabel")}</span>,
                                value: assistedReport.InVitroFertilization.Description,
                                onChange: value => this.mutateAssistedReproductiveTechnologyModel(
                                    s => {
                                        if (!IsNullOrWhiteSpace(value))
                                            s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();

                                        s.Section5.AssistedReproductiveTechnology.InVitroFertilization.setDescription(value || "", !!value);
                                    },
                                    false,
                                    null,
                                    value != null
                                ),
                                maxLength: this.page1FieldLimits.PresentPregnancy_AntiretroviralTherapy_InVitroFertilizationNumberOfEmbryos.MaxChars,
                                valueStyle: { width: "25%" },
                                isNumeric: true,
                                min: 0,
                                flexDisplay: true
                            })
                        )}
                        {this.renderRadioCheckboxWithLabel(
                            "PresentPregnancy_ICSI",
                            "IntracytoplasmicSpermInjectionAbbreviationLabel",
                            assistedReport.IntracytoplasmicSpermInjection.Value,
                            value => {
                                this.mutateAssistedReproductiveTechnologyModel(
                                    s => {
                                        s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();
                                        s.Section5.AssistedReproductiveTechnology.IntracytoplasmicSpermInjection.Value = value;
                                    },
                                    true,
                                    () => this.setFocusTextbox(value, this.AssistedReproductiveTechnology_IntracytoplasmicSpermInjectionId)
                                );
                            },
                            this.getAdditionalTextBox({
                                id: this.AssistedReproductiveTechnology_IntracytoplasmicSpermInjectionId,
                                label: <span># {this.getString("ObstetricalFile_EmbryosTransferredLabel")}</span>,
                                value: assistedReport.IntracytoplasmicSpermInjection.Description,
                                onChange: value => this.mutateAssistedReproductiveTechnologyModel(
                                    s => {
                                        if (!IsNullOrWhiteSpace(value))
                                            s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();

                                        s.Section5.AssistedReproductiveTechnology.IntracytoplasmicSpermInjection.setDescription(value || "", !!value);
                                    },
                                    false,
                                    null,
                                    value != null
                                ),
                                maxLength: this.page1FieldLimits.PresentPregnancy_AntiretroviralTherapy_IntracytoplasmicSpermInjectionNumberOfEmbryos.MaxChars,
                                valueStyle: { width: "25%" },
                                isNumeric: true,
                                min: 0,
                                flexDisplay: true
                            })
                        )}
                        {this.renderRadioCheckboxWithLabel(
                            "PresentPregnancy_Other",
                            "ObstetricalFile_OtherLabel",
                            assistedReport.Other.Value,
                            value => {
                                this.mutateAssistedReproductiveTechnologyModel(
                                    s => {
                                        s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();
                                        s.Section5.AssistedReproductiveTechnology.Other.Value = value;
                                    },
                                    true,
                                    () => this.setFocusTextbox(value, this.AssistedReproductiveTechnology_OtherId)
                                );
                            },
                            this.getAdditionalTextBox({
                                id: this.AssistedReproductiveTechnology_OtherId,
                                value: section5.AssistedReproductiveTechnology.Other.Description,
                                onChange: value => this.mutateAssistedReproductiveTechnologyModel(
                                    s => {
                                        if (!IsNullOrWhiteSpace(value))
                                            s.Section5.AssistedReproductiveTechnology.setAllchildFieldsAsFalse();
                                        s.Section5.AssistedReproductiveTechnology.Other.setDescription(value, !!value);
                                    }
                                ),
                                valueClassName: "margin-xs-left",
                                maxLength: this.page1FieldLimits.PresentPregnancy_AntiretroviralTherapy_OtherDescription.MaxChars
                            })
                        )}

                    </div>
                    {this.renderRadioButtonsWithTextBox({
                        value: section5.Bleeding,
                        id: "PresentPregnancy_Bleeding",
                        label: "BleedingLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section5.Bleeding.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section5.Bleeding.setDescription(value)),
                        maxLength: this.page1FieldLimits.PresentPregnancy_BleedingDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section5.Nausea,
                        id: "PresentPregnancy_Nausea",
                        label: "NauseaLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section5.Nausea.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section5.Nausea.setDescription(value)),
                        maxLength: this.page1FieldLimits.PresentPregnancy_NauseaDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section5.Traveled,
                        id: "PresentPregnancy_TravelSelfPartner",
                        label: "ObstetricalFile_TravelSelfPartnerLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section5.Traveled.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section5.Traveled.setDescription(value)),
                        maxLength: this.page1FieldLimits.PresentPregnancy_TravelDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section5.Infection,
                        id: "PresentPregnancy_InfectionRashFever",
                        label: "ObstetricalFile_InfectionRashFeverLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section5.Infection.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section5.Infection.setDescription(value)),
                        maxLength: this.page1FieldLimits.PresentPregnancy_InfectionRashFeverDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section5.Other,
                        id: "PresentPregnancy_HasOther",
                        label: "ObstetricalFile_OtherLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section5.Other.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section5.Other.setDescription(value)),
                        maxLength: this.page1FieldLimits.PresentPregnancy_OtherDescription.MaxChars
                    })}
                    {this.renderAllEmptyFieldAsNoLink(
                        () => this.props.mutateModelStateWithFormUpdate(s => s.Section5.setEmptyFieldsAsNo())
                    )}
                </div>
            </div>
        );
    }

    private mutateAssistedReproductiveTechnologyModel(mutation: (state: BritishColumbiaObstetricalFileForm) => void, updateForm?: boolean, then?: () => void, shouldUpdateAssistedReproductiveTechnology: boolean = true): void {
        this.props.mutateModelState(
            s => {
                mutation(s);
                if (shouldUpdateAssistedReproductiveTechnology && s.Section5.AssistedReproductiveTechnology.HasAssistedReproductiveTechnology === null)
                    s.Section5.AssistedReproductiveTechnology.HasAssistedReproductiveTechnology = s.Section5.AssistedReproductiveTechnology.hasSelectedAnyAssistedReproductiveTechnology();
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();

                then?.();
            }
        );
    }
}

export { BritishColumbiaObstetricalFileSection5 };
